// extracted by mini-css-extract-plugin
export default {"user_icon_container":"UserIcon_user_icon_container__8-bCb","user_icon":"UserIcon_user_icon__dX960"};